import KEditor from './KEditor.vue'

export {
  KEditor
}
